export default function getActivePage () {
  const getActivePageId = () => String(INKIVE.Tool._current_design_id);
  const getActivePageIndex = () => parseInt(INKIVE.Tool._current_page_number) - 1;
  const getActivePageNumber = () => parseInt(INKIVE.Tool._current_page_number);
  const getActivePageContent = () => {
    const currentPageSvgString = INKIVE.EditorFacade.editor.getSvgString();
    return currentPageSvgString;
  };
  const getTextMockContent = () => {
    const textMock = document.getElementById('textmock');
    const textMockSvgString = textMock ? INKIVE.EditorFacade.editor.getSvgString(textMock) : '';
    return textMockSvgString;
  };

  return {
    id: getActivePageId(),
    index: getActivePageIndex(),
    number: getActivePageNumber(),
    textMockContent: getTextMockContent(),
    content: getActivePageContent()
  };
}
